/*--------------------------------------------------------------
# Theme
--------------------------------------------------------------*/

// Hide buttons when play scene
let playScene = false;
let hidableBtn = document.querySelectorAll('.hidable');

const playBtn = document.querySelector('#play-scene');
const audio = document.querySelector("#background-music")

if (playBtn != null)
{
    playBtn.addEventListener('click', () =>
    {
        if (playScene)
        {
            playBtn.classList.remove("playing");
            window.collage.pauseScene();
            audio.pause();

            hidableBtn.forEach(elem =>
            {
                elem.classList.remove("hidden");
                playScene = false;
            });
        }
        else
        {
            playBtn.classList.add("playing");
            window.collage.playScene();
            audio.play();


            hidableBtn.forEach(elem =>
                               {
                elem.classList.add("hidden");
                playScene = true;
            });
        }
    });
}
